function getVerticalScrollParent(from: HTMLElement): HTMLElement | null {
	let parent: HTMLElement | null = from.parentElement;

	while (parent) {
		const style = getComputedStyle(parent);
		const overflowY = style.overflowY;
		const scrollable = overflowY === 'auto' || overflowY === 'scroll';

		if (scrollable && parent.scrollHeight > parent.clientHeight + 1) {
			return parent;
		}

		parent = parent.parentElement;
	}

	return null;
}

function scrollElementToTopInNearestScrollableAncestor(element: HTMLElement): HTMLElement | null {
	const scrollParent = getVerticalScrollParent(element);

	if (!scrollParent) {
		element.scrollIntoView({ block: 'start', behavior: 'auto', inline: 'nearest' });
		return null;
	}

	const rect = element.getBoundingClientRect();
	const parentRect = scrollParent.getBoundingClientRect();
	const delta = rect.top - parentRect.top;

	scrollParent.scrollTo({
		top: Math.max(0, scrollParent.scrollTop + delta),
		behavior: 'auto'
	});

	return scrollParent;
}

/** Object export so tests can `spyOn(elementScrollUtil, 'scrollElementToTopInNearestScrollableAncestor')` (Jasmine cannot spy on ESM named exports). */
export const elementScrollUtil = {
	scrollElementToTopInNearestScrollableAncestor
};
